import { Component, Input } from '@angular/core';
import { QsaDetails, QsaPartnerDetails } from '../../models/child-models/qsa-details.model';

export interface QsaDetailRow {
  participation: string;
  partner: QsaPartnerDetails;
  representatives: QsaPartnerDetails[];
}

export interface QsaDetailGroup {
  title: string;
  rows: QsaDetailRow[];
}

@Component({
  selector: 'app-qsa-data-detail',
  templateUrl: './qsa-data-detail.component.html',
  styleUrls: ['./qsa-data-detail.component.scss'],
  standalone: false,
})
export class QsaDataDetailComponent {
  public rows: QsaDetailRow[] = [];
  public groups: QsaDetailGroup[] = [];

  @Input()
  public set qsa(qsa: QsaDetails) {
    this.groups = (qsa?.partners ?? []).map((partner) => {
      const rows: QsaDetailRow[] = [];
      this.flatten([partner], rows);
      return { title: partner.personType === 'J' ? 'Sócio Pessoa Jurídica' : 'Sócio Pessoa Física', rows };
    });
    this.rows = [].concat(...this.groups.map((group) => group.rows));
  }

  private flatten(partners: QsaPartnerDetails[], rows: QsaDetailRow[]) {
    partners?.forEach((partner) => {
      rows.push({
        participation: this.formatPercent(partner.participationPercent),
        partner,
        representatives: partner.legalRepresentatives ?? [],
      });
      this.flatten(partner.partners, rows);
    });
  }

  private formatPercent(value: number): string {
    return value == null ? '' : `${value}`.replace('.', ',');
  }
}
